import { DashboardTimeFrame } from 'containers/dashboard/types/types';
import { IDashboardChartPayloadType } from '../types/types';
import useChartTooltipValueFormatter from './useChartTooltipValueFormatter';
import useChartTooltipTimeFrameTitleFormatter from './useChartTooltipTimeFrameTitleFormatter';

export default function useTooltipFormatter(valueType: IDashboardChartPayloadType, timeFrame: DashboardTimeFrame) {
  return {
    titleFormatter: useChartTooltipTimeFrameTitleFormatter(timeFrame),
    valueFormatter: useChartTooltipValueFormatter(valueType),
  };
}
